import { isLoading } from '../../../../constants/actionConstants';
import { ViewSave } from './service';
import { toast } from "react-toastify";



export function updateSaveView80iac(params) {
    return async function (dispatch) {
        dispatch(isLoading(true));
        ViewSave.saveView80iac(params).then(responce => {
            const { message, status } = responce;
            if (status) {
                toast.success(message)
            } else {
                toast.error(message)
            }
            dispatch(isLoading(false))
        }).catch(e => {
            toast.error(e)
            dispatch(isLoading(false))
        })

    }
}